import { render, staticRenderFns } from "./CheckPenaltiesByDriverLicenceModal.vue?vue&type=template&id=f9d5a7a0&scoped=true&"
import script from "./CheckPenaltiesByDriverLicenceModal.vue?vue&type=script&lang=js&"
export * from "./CheckPenaltiesByDriverLicenceModal.vue?vue&type=script&lang=js&"
import style0 from "./CheckPenaltiesByDriverLicenceModal.vue?vue&type=style&index=0&id=f9d5a7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d5a7a0",
  null
  
)

export default component.exports